import { render, staticRenderFns } from "./TMPlacements.man.vue?vue&type=template&id=d2deca54&scoped=true&lang=html&"
import script from "./TMPlacements.man.vue?vue&type=script&lang=js&"
export * from "./TMPlacements.man.vue?vue&type=script&lang=js&"
import style0 from "./TMPlacements.man.vue?vue&type=style&index=0&id=d2deca54&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2deca54",
  null
  
)

export default component.exports